import { eBranches } from "sb-helpers";
import { Scoreboards } from "../../constants";
export const mapGamePart = (x) => {
    x.gamePart = x.liveGameState && x.liveGameState.gamePart && !Scoreboards[eBranches[x.sportId]]
        ? x.liveGameState.gamePart : "";
    return x;
};
//# sourceMappingURL=mapGamePart.js.map